/* CDX Warenkorb-Wächter — entfernt verwaiste Aufpreis-Positionen.
 *
 * HINTERGRUND (Test vom 02.08.2026): Teeinblue legt den Aufpreis als EIGENE
 * Warenkorb-Position an. Hauptartikel und Aufpreis hängen nur über eine
 * Kennung zusammen:
 *
 *   Hauptartikel : properties._customization_id      = "aac93bb8-…"
 *   Aufpreis     : properties._tib_customization_id  = "aac93bb8-…"
 *
 * Wird der Hauptartikel entfernt, bleibt der Aufpreis allein im Warenkorb
 * stehen — beobachtet mit einer Hundemarke: Hauptartikel weg, "5,00 €" blieb.
 * Ein Kunde kann so eine reine Aufpreis-Position bestellen, die nichts enthält.
 *
 * VORGEHEN, bewusst eng gefasst:
 * - Es wird ausschliesslich eine Position entfernt, die eine
 *   `_tib_customization_id` trägt UND zu der KEIN Hauptartikel mit derselben
 *   `_customization_id` mehr im Warenkorb liegt. Alles andere bleibt unberührt.
 * - Wer den Aufpreis-Artikel direkt kauft (ohne Konfigurator), hat diese
 *   Eigenschaft nicht und wird nicht angefasst.
 * - Nach dem Entfernen wird die Seite einmal neu geladen. Danach gibt es keine
 *   Waise mehr, also auch keinen zweiten Durchlauf — keine Schleife.
 * - Jeder Fehler wird verschluckt: im Zweifel passiert nichts.
 */
(function () {
  'use strict';
  var laeuft = false;

  function entferneWaisen() {
    if (laeuft) return;
    laeuft = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { laeuft = false; return; }

        var vorhanden = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._customization_id) vorhanden[p._customization_id] = true;
        });

        var waisen = cart.items.filter(function (it) {
          var p = it.properties || {};
          var id = p._tib_customization_id;
          return id && !vorhanden[id];
        }).map(function (it) { return it.key; });

        if (!waisen.length) { laeuft = false; return; }

        var naechste = function () {
          var key = waisen.shift();
          if (!key) { window.location.reload(); return; }
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(naechste).catch(function () { laeuft = false; });
        };
        naechste();
      })
      .catch(function () { laeuft = false; });
  }

  /* Nach jeder Mengenaenderung und jedem Entfernen nachsehen. Der Verzug gibt
     dem Theme Zeit, seine eigene Warenkorb-Aktualisierung abzuschliessen. */
  function spaeterPruefen() { setTimeout(entferneWaisen, 900); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('cart-remove-button, .cart-remove-button, [name="minus"], [name="plus"]')) spaeterPruefen();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.quantity, quantity-input')) spaeterPruefen();
  }, true);

  /* Beim Aufruf der Warenkorb-Seite einmal aufraeumen — dort landet, wer den
     Artikel vorher woanders entfernt hat. */
  if (/^\/cart/.test(window.location.pathname)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', entferneWaisen);
    } else {
      entferneWaisen();
    }
  }
})();
